import type { JSX } from "preact";
import { Button } from "@gss/components/Button";
import { Link } from "@gss/components/icons";
import { useTranslation } from "../util/Translation";

interface Props {
    onClick: () => void;
    inMultiSelection: boolean;
    disabled: boolean;
    buttonText?: boolean;
    className?: string;
}

export function ButtonMultiSelect({
    onClick,
    inMultiSelection,
    disabled,
    buttonText,
    className,
}: Props): JSX.Element {
    const t = useTranslation().translation.filters;
    const text = inMultiSelection
        ? t.multiSelectionSave
        : t.multiSelectionCreate;
    return (
        <Button
            variant={inMultiSelection ? "primary" : "default"}
            small
            className={className}
            disabled={disabled}
            title={!buttonText ? text : undefined}
            aria-label={!buttonText ? text : undefined}
            aria-pressed={inMultiSelection}
            onClick={onClick}
        >
            <Link className="icon-multiselect" aria-hidden />
            {buttonText && ` ${text}`}
        </Button>
    );
}
